import Scheduled from "./Scheduled";
import Asset from "./Asset";
import {isoToLocalDate} from "../stores/StoreUtilities";
import IModelItem from "./IModelItem";
import IBudget from "./iBudget";
import Person from "./Person";

export enum DeductionType {
  Other = 0,
  BeforeTax,
  AfterTax,
  Employer
}

class Deduction extends Scheduled implements IModelItem, IBudget {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  description: string
  amount: number
  amountDate: Date
  infLock: boolean
  annualInf: number
  sortOrder: number
  assetId: string
  asset?: Asset
  paycheckId?: string
  ownerId: string
  owner?: Person
  archived: boolean
  deductionType: DeductionType

  constructor(data: any) {
    super(data)
    this.id = data.id
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.accountId = data.accountId
    this.userId = data.userId
    this.modelId = data.modelId
    this.description = data.description ?? "Other"
    this.amount = data.amount ?? 0
    this.amountDate = data.amountDate ? isoToLocalDate(data.amountDate) : isoToLocalDate(data.updatedAt)
    this.infLock = data.infLock
    this.annualInf = data.annualInf
    this.sortOrder = data.sortOrder
    this.assetId = data.assetId
    this.paycheckId = data.paycheckId
    this.ownerId = data.ownerId
    this.archived = data.archived === true
    this.deductionType = data.deductionType ?? DeductionType.Other
  }

  getTypename(): string {
    return "Deduction"
  }

  get endDate(): Date | undefined {
    let endDate = this.model?.getDate(this.end)
    if (!endDate && (this.asset && this.asset.owner && this.asset.owner.retireDate)) {
      // Default to owner retire date
      endDate = isoToLocalDate(this.asset.owner.retireDate)
    }
    return endDate
  }

  get endYear(): number {
    const date = this.endDate
    if (date) {
      return date.getFullYear()
    } else {
      return 0
    }
  }
}

export default Deduction